<template>
    <b-modal
        id="magazine-color-modal"
        v-model="modal"
        modal-class="apprentice-default-modal"
        ok-only
        :ok-title="$t('common.save')"
        ok-variant="primary"
        size="md"
        @ok="onOk"
        :title="$t('magazine.select_color')">
        <b-form-select
            v-model="color"
            :class="[color ? 'bg-' + color : '']">
            <b-form-select-option
                :value="null"
                :class="['bg-light']"
                >{{ $t('magazine.select_color') }}
            </b-form-select-option>
            <b-form-select-option
                v-for="option in colorOptions"
                :class="'bg-' + option.value"
                :value="option.value"
                :key="option.value"
                >{{ option.name }}
            </b-form-select-option>
        </b-form-select>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-magazine-yearbooks-color-modal-component',
    data() {
        return {
            modal: false,
            magazine: null,
            color: null,
            colorOptions: [
                {
                    name: this.$t('magazine.blue'),
                    value: 'primary',
                },
                {
                    name: this.$t('magazine.green'),
                    value: 'success',
                },
                {
                    name: this.$t('magazine.yellow'),
                    value: 'warning',
                },
                {
                    name: this.$t('magazine.red'),
                    value: 'danger',
                },
                {
                    name: this.$t('magazine.dark'),
                    value: 'dark',
                },
            ],
        };
    },
    methods: {
        show(magazine) {
            this.magazine = magazine;
            this.color = magazine.color;
            this.modal = true;
        },
        setColor($event) {
            this.color = $event.value;
        },
        onOk() {
            const data = {
                comment: this.magazine.comment,
                todo: this.magazine.todo,
                color: this.color,
            };
            this.axios.post(this.routes.magazineAdminValues(this.magazine.id), data).then(
                (response) => {
                    this.$emit('update-admin-values', { id: this.magazine.id, values: data });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
    computed: {
        selector: function () {
            if (!this.color || this.color === this.$t('magazine.select_color')) {
                return this.$t('magazine.select_color');
            } else {
                return this.color;
            }
        },
        selectedColor() {
            for (const option of this.colorOptions) {
                {
                    if (option.value === this.color) {
                        return option;
                    }
                }
            }

            return null;
        },
    },
};
</script>

<style scoped></style>
